import { CreditCardOutlined, UserOutlined, UsergroupAddOutlined } from '@ant-design/icons'
import Billing from '../../pages/Billing'
import UserGroups from '../../pages/UserGroups'
import Users from '../../pages/Users'
import { permissions } from '../../types/authorization'
import type { ProtectedRouteDescriptor } from '../types'

export const administrationRoutes: ProtectedRouteDescriptor[] = [
  {
    key: 'users',
    path: 'users',
    element: <Users />,
    access: { anyOf: [permissions.viewUser] },
    nav: {
      sectionKey: 'administration',
      label: 'Users',
      Icon: UserOutlined,
      order: 10,
    },
  },
  {
    key: 'user-groups',
    path: 'user-groups',
    element: <UserGroups />,
    access: { anyOf: [permissions.viewUserGroup] },
    nav: {
      sectionKey: 'administration',
      label: 'User Groups',
      Icon: UsergroupAddOutlined,
      order: 20,
    },
  },
  {
    key: 'billing',
    path: 'billing',
    element: <Billing />,
    access: { anyOf: [permissions.viewBilling] },
    nav: {
      sectionKey: 'administration',
      label: 'Billing',
      Icon: CreditCardOutlined,
      order: 30,
    },
  },
]
